/* start - flights_split_bounds_us */
import { StoreState } from "store";

export const getSearchFetchStatus = (state: StoreState) => state.searchResultsBounds.outbound.fetchStatus;
export const getSearchResultsFlights = (state: StoreState) => state.searchResultsBounds.outbound.flights;
export const getSearchPointOfSale = (state: StoreState) =>
  state.searchResultsBounds?.outbound?.flights?.[0]?.pointOfSale;
export const getSearchResultsFetchedAt = (state: StoreState) => state.searchResultsBounds.outbound.fetchedAt;
export const getSearchResultsFlightOffers = (state: StoreState) => state.searchResultsBounds.outbound.flights;
export const getSearchResultsFlightDeals = (state: StoreState) => state.searchResultsBounds.outbound.flightDeals;
export const getSearchId = (state: StoreState) => state.searchResultsBounds.outbound.searchId;
export const getSearchAvailableFilters = (state: StoreState) => state.searchResultsBounds.outbound.availableFilters;
export const getSearchDisplayOptions = (state: StoreState) => state.searchResultsBounds.outbound.displayOptions;
export const getAvailableFilters = (state: StoreState) => state.searchResultsBounds.outbound.availableFilters || {};
export const getSearchResultsBanners = (state: StoreState) => state.searchResultsBounds.outbound.banners;
export const getSearchResultsError = (state: StoreState) => state.searchResultsBounds.outbound.error;
export const getSearchResultsSubsidizedFaresSummary = (state: StoreState) =>
  state.searchResultsBounds.outbound.subsidizedFaresSummary;
export const getSearchResultsSearchCriteria = (state: StoreState) => state.searchResultsBounds.outbound.searchCriteria;
export const getSearchResultsAtolProtectedStatus = (state: StoreState) =>
  state.searchResultsBounds.outbound.atolProtectedStatus;
export const getSearchResultsBaggagePolicies = (state: StoreState) =>
  state.searchResultsBounds.outbound.baggagePolicies;
export const getSearchResultsCampaignBanner = (state: StoreState) => state.searchResults.campaignBanner;
export const getSearchResultsRemoteBanners = (state: StoreState) => state.searchResults.remoteBanners;
/* end - flights_split_bounds_us */
